<template>
    <div class="charts_box">
        <div class="charts_box_bar_box">
            <h3>您的财务情况</h3>
            <div id='myChart' class="charts_bar" ref="chartsBar" style="">

            </div>
            <div class="charts_box_item_total">
                <span style="color:#2ecc71;font-size:18px;">+{{total}}</span><br/>总体收益
            </div>
        </div>
        <div class="charts_box_line_box"> 
            <h3>您的收益 每月</h3>
            <div ref="chartsLine" class="charts_line" style="width:100%;">
                
            </div>
        </div>
    </div>
  
</template>
<script>

export default {
    data() {
        return {
            data1: [],
            data2: [],
            data3: [],
            dataArr: [],
            total: 0
        }
    },
    methods: {
        FinancialsituationBar(){
            //财务状况
            this.$getCharts('/Handler/FYGL.ashx',{action:'GetNegotiatorFinancial',isArray:true},data => {
                let that = this;
                this.total = data.ExtendData.total;
                data.ExtendData.nearTwoMonths.forEach(function(el){
                    that.data3.push(el.month+'月');
                    that.data1.push(el.money);
                    that.data2.push(50000-el.money);
                })
                this.drawBar(this.data1,this.data2,this.data3);
            },err => {

            });
        },
        FinancialsituationLine(){
            this.$get('/Handler/FYGL.ashx',{action:'GetNegotiatorFinancial',isArray:true},data => {
                
                this.dataArr = data;
                this.drawLine(this.dataArr);
            },err => {

            });
        },
        drawBar(data1,data2,data3){
        // 基于准备好的dom，初始化echarts实例
            let bar_dv = this.$refs['chartsBar'];
            if(bar_dv){
                let myChartbar = this.$echarts.init(bar_dv);
                // 绘制图表
                myChartbar.setOption({
                    title: { text: '' },
                    tooltip: {},
                    xAxis: {
                        data: data3,
                        silent: false,
                        axisLine: {onZero: false},
                        splitLine: {show: false},
                        splitArea: {show: false},
                        axisLine:{show:false},
                        axisTick:{show:false}
                    },
                    yAxis: {
                        inverse: false,
                        splitArea: {show: false},
                        splitLine: {show: false},
                        axisLine:{show:false},
                        axisTick:{show:false}
                    },
                    grid: {
                        left: 0,
                        top:0
                    },
                    series: [
                        {
                            name: '已回款',
                            type: 'bar',
                            stack: 'one',
                            itemStyle : {  
                                normal : {  
                                    borderWidth:'1',
                                    color:'#2ecc71',  
                                    lineStyle:{  
                                        color:'#2ecc71'  
                                    }  
                                }  
                            }, 
                            data: data1
                        },
                        {
        		            // name: '未回款',
                            type: 'bar',
                            stack: 'one',
                            itemStyle : {  
                                normal : {  
                                    borderWidth:'1',
                                    color:'#666',  
                                    lineStyle:{  
                                        color:'#2ecc71'  
                                    }  
                                },
                                label:{
                                    show: false
                                }  
                            }, 
                            data: data2
                        }
                    ]
                });

            }else{
                
            }
        },
        drawLine(dataArr){
            let line_dv = this.$refs['chartsLine'];
            if(line_dv){
                let myChartline = this.$echarts.init(line_dv);
                // 绘制图表
                myChartline.setOption({
                    title: { text: '' },
                    toolbox: {
                        
                    },
                    tooltip: {},
                    xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: ['1','2','3','4','5','6','7','8','9','10','11','12'],
                            minInterval: 1,
                            splitArea:{show:false},
                            splitLine: {show: false},
                            axisLine:{show:false},
                            axisTick:{show:false},
                            inverse: false
                        },
                    yAxis: {
                        inverse: false,
                        splitArea: {show: true},
                        splitLine: {show: false},
                        axisLine:{show:false},
                        axisTick:{show:false}
                    },
                    grid: {
                        left: 4,
                        top:0
                    },
                    series: [
                        {
                            name: '收益',
                            type: 'line',
                            stack: 'one',
                            itemStyle : {  
                                normal : {  
                                    borderWidth:'1',
                                    color:'#2ecc71',  
                                    lineStyle:{  
                                        color:'#2ecc71'  
                                    }  
                                }  
                            }, 
                            data: dataArr
                        }
                    ]
                })
            }else{
                
            }

        }
    },
    mounted() {
        this.FinancialsituationBar();
         this.FinancialsituationLine();
    },
    created(){
    }
}
</script>
<style>
.charts_box{
    position: relative;
}
.charts_box h3{
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
    padding-left: 8px;
}
.charts_box_item_total{
    position: absolute;
    right: 0px;
    top: 50px;
    color: #ccc;
    font-size: 14px;
    text-align: right;
}
.charts_box_bar_box{
    width:170px;
}
.charts_bar{
    height: 150px;
}
.charts_line{
    height: 300px;
}
</style>




// WEBPACK FOOTER //
// src/components/myecharts/myecharts.vue